import { render } from "./GenerateToken.vue?vue&type=template&id=58080988&scoped=true"
import script from "./GenerateToken.vue?vue&type=script&lang=js"
export * from "./GenerateToken.vue?vue&type=script&lang=js"

import "./GenerateToken.vue?vue&type=style&index=0&id=58080988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58080988"]])

export default __exports__